let apiPromise = null;

// Loads Spotify's official IFrame API once and resolves with the IFrameAPI object.
export function loadSpotifyIframeApi() {
  if (apiPromise) return apiPromise;
  apiPromise = new Promise((resolve) => {
    if (window.__spotifyIframeApi) {
      resolve(window.__spotifyIframeApi);
      return;
    }
    window.onSpotifyIframeApiReady = (IFrameAPI) => {
      window.__spotifyIframeApi = IFrameAPI;
      resolve(IFrameAPI);
    };
    const script = document.createElement("script");
    script.src = "https://open.spotify.com/embed/iframe-api/v1";
    script.async = true;
    document.body.appendChild(script);
  });
  return apiPromise;
}
